var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 34.4375C9.26246 34.4375 1.97913 27.1542 1.97913 18.2084C1.97913 9.26252 9.26246 1.97919 18.2083 1.97919C27.1541 1.97919 34.4375 9.26252 34.4375 18.2084C34.4375 27.1542 27.1541 34.4375 18.2083 34.4375ZM18.2083 4.35419C10.5608 4.35419 4.35413 10.5767 4.35413 18.2084C4.35413 25.84 10.5608 32.0625 18.2083 32.0625C25.8558 32.0625 32.0625 25.84 32.0625 18.2084C32.0625 10.5767 25.8558 4.35419 18.2083 4.35419Z",
    fill: "url(#paint0_linear_206_549)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 36.0209C34.5325 36.0209 34.2316 35.91 33.9941 35.6725L30.8275 32.5059C30.3683 32.0467 30.3683 31.2867 30.8275 30.8275C31.2866 30.3684 32.0466 30.3684 32.5058 30.8275L35.6725 33.9942C36.1316 34.4534 36.1316 35.2134 35.6725 35.6725C35.435 35.91 35.1341 36.0209 34.8333 36.0209Z",
    fill: "url(#paint1_linear_206_549)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_206_549",
    x1: 1.97913,
    y1: 17.379,
    x2: 36.0168,
    y2: 17.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_206_549",
    x1: 1.97913,
    y1: 17.379,
    x2: 36.0168,
    y2: 17.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d381be82cadb8b0ad8cd3f620b149f9f.svg";
export { ForwardRef as ReactComponent };